(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kjallt-card-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kjallt-card-colors')) {
    customElements.define('kjallt-card-colors', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('pointerover', (e) => {
          const t = e.target.closest('.kcc__t');
          if (t && e.pointerType !== 'touch') this.show(t.dataset.large);
        });
        this.addEventListener('focusin', (e) => {
          const t = e.target.closest('.kcc__t');
          if (t) this.show(t.dataset.large);
        });
        this.addEventListener('pointerleave', () => this.hide());
        this.addEventListener('focusout', () => this.hide());
      }
      gallery() {
        const card = this.closest('product-card');
        return card && card.querySelector('.card-gallery');
      }
      show(src) {
        const g = this.gallery();
        if (!g) return;
        let o = g.querySelector('.kcc-over');
        if (!o) {
          o = document.createElement('img');
          o.className = 'kcc-over';
          o.alt = '';
          if (getComputedStyle(g).position === 'static') g.style.position = 'relative';
          g.appendChild(o);
        }
        o.src = src;
      }
      hide() {
        const g = this.gallery();
        const o = g && g.querySelector('.kcc-over');
        if (o) o.remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
